import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, map, filter } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { UpdateField } from '../action-creators';
import { CREATE_OWNERSHIP_SUCCESS, REMOVE_OWNERSHIP_SUCCESS } from '../../ownership/actions';
import { ownersList } from '../../ownership/selectors';
import { trackList } from '@webapp/store/tracks/selectors';

export const updateOwnerCountEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action>(
      CREATE_OWNERSHIP_SUCCESS,
      REMOVE_OWNERSHIP_SUCCESS
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.release.release?.id),
    map(([_, state]) => {
      const tracks = trackList(state.tracks.tracks, state.release.release?.id);

      const ownerCount = tracks
        .filter((track) => !!track.id)
        .reduce((memo, track) => {
          const owners = ownersList(state.ownership, track.id as string)
            .map((o) => o.ownerId || o.contact)
            .filter((o) => !memo.includes(o));

          return memo.concat(owners)
        }, [] as string[])
        .length;

      return new UpdateField<'ownerCount'>('ownerCount', ownerCount);
    })
  );
